import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import PostHooks from "../../../Api/PostHooks";
import AlertComponent from "../../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { login } from "../../../Redux/authSlice";
import { userData } from "../../../Redux/userSlice";
import { useDispatch } from "react-redux";
import FormNumberInput from "../../../Components/FormNumberInput";

const OtpForm = () => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [user, setUser] = useState(location.state.user);
  const [otpData, setOtpData] = useState(location.state.otpData);
  const [timer, setTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [loading, response, request] = PostHooks();

  useEffect(() => {
    if (otpData && otpData.Minutes) {
      setTimer(otpData.Minutes * 60);
    }
  }, [otpData]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setResendDisabled(false);
    }
  }, [timer]);

  const onSubmit = async (e) => {
    try {
      let formData = {
        msisdn: user.msisdn,
        otp: e.otp,
      };
      let props = {
        url: "/verify_login_otp",
        body: formData,
      };

      const otpResp = await request(props);

      if (otpResp && otpResp.status === 200 && otpResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Success, redirecting ...",
        });
        dispatch(login(otpResp.data));
        dispatch(userData(otpResp.data.PayLoad));

        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } else if (
        otpResp &&
        (otpResp.status === 200 || otpResp.status === 201) &&
        otpResp.data.StatusCode === 2
      ) {
        // navigate(-1);
        setTimer(0);

        const errorMessage =
          otpResp?.data?.StatusMessage ??
          otpResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      } else {
        const errorMessage =
          otpResp?.data?.StatusMessage ??
          otpResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }

      console.log(otpResp);
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Grid
        item
        xs={12}
        sx={{
          paddingTop: "20px",
        }}
      >
        <FormNumberInput
          name="otp"
          control={control}
          label={`OTP`}
          minLength={4}
          maxLength={4}
          hidesteppers={true}
          disableGrouping={true}
          rules={{
            required: "Please enter a valid otp!",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.otp}>
          <InputLabel htmlFor="otp">OTP</InputLabel>
          <OutlinedInput
            id="otp"
            type="number"
            {...register("otp", {
              required: true,
              maxLength: 4,
              minLength: 4,
            })}
            label="OTP"
          />
          {errors.otp && (
            <FormHelperText>Please enter a valid otp!</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          paddingTop: "30px",
          gap: "20px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "baseline",
        }}
      >
        <Box>
          {timer > 0 ? (
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              Time remaining: {formatTime(timer)}
            </Typography>
          ) : (
            <Button variant="text" onClick={() => navigate(-1)}>
              Resend otp
            </Button>
          )}
        </Box>

        <LoadingButton
          variant="contained"
          size="large"
          type="submit"
          loading={loading}
        >
          confirm
        </LoadingButton>
      </Grid>
    </form>
  );
};

export default OtpForm;
